import { brandLogo } from '@/utils/brandLogo'
import { currencyFormat } from '@/utils/currencyFormat'
import { StatusColor } from '@/utils/StatusColor.utility'
import moment from 'moment'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { IConfigSeller } from '@/models/configSeller'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import qrCode from 'qrcode'
import { useJoyRideContext } from '../context/JoyRideContext'

const Detail = () => {
  const { ctx } = useTradeinContext()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const [urlQrCode, setUrlQrCode] = useState<string | null>(null)
  const { setRunTour, setSteps } = useJoyRideContext()
  const isWom = configSeller.config.s3.FOLDER_APP === 'ti_wom'

  // WOM: al extra bono se le suma el descuento vigente (el recalculado si existe, si no el original).
  const showWomBoost = isWom && ctx.tradein.device_boost !== null && ctx.tradein.device_boost !== undefined
  const discountAmount = ctx.tradein.new_discount_amount !== null ? ctx.tradein.new_discount_amount : ctx.tradein.discount_amount
  const womTotal = Number(ctx.tradein.device_boost ?? 0) + Number(discountAmount ?? 0)

  useEffect(() => {
    if (!ctx.tradein.id || ctx.tradein.id === 0) return
    if ((ctx.tradein.id_sbu === 1 || (ctx.tradein.id_sbu === 3 && ctx.tradein.brand === 'Apple'))) {
      const idTradein = ctx.tradein.id
      const url = `https://${import.meta.env.VITE_BUCKET}.s3.us-west-2.amazonaws.com/${configSeller.config.s3.FOLDER_APP}/imagenes/${idTradein}/login_code_qr.png`
      setUrlQrCode(url)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.tradein.id, configSeller.config.s3.FOLDER_APP])

  const handleQrError = () => {
    const code = ctx.tradein.login_code
    if (!code) return
    qrCode.toDataURL(`https://cloudportal.phonecheck.com/cloud/remoteApp/configuration?pin=${code}`, { errorCorrectionLevel: 'H' }, (err, url) => {
      if (!err) setUrlQrCode(url)
    })
  }

  useEffect(() => {
    if (ctx.tradein.id_status === 1 && (ctx.tradein.id_sbu === 1 || (ctx.tradein.id_sbu === 3 && ctx.tradein.brand === 'Apple'))) {
      setSteps([{
        target: '.step-pcheck',
        content: 'El cliente debe ingresar este codigo o escanear el código QR para realizar el test en su celular desde la aplicacion Phonecheck.',
        placement: 'right',
        disableBeacon: true
      }, {
        target: '.step-1',
        content: 'Si el cliente ya hizo el test en su celular presione este botón',
        placement: 'bottom',
        disableBeacon: true
      }])
      setRunTour(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.tradein.id_status])

  return (
    <div className='bg-white rounded-lg shadow-lg p-4'>
      <h6 className='border-b-1 mb-2 font-bold text-xl pb-2'>Detalle</h6>
      <ul className='px-4'>
        <li className='py-4'>
          {
              ctx.tradein.wasRecalculated === 1
                ? (<img src={brandLogo(String(ctx.tradein.make))} alt={ctx.tradein.make} style={{ maxHeight: '40px', maxWidth: '100%' }} />)
                : (<img src={brandLogo(String(ctx.tradein.brand))} alt={ctx.tradein.brand} style={{ maxHeight: '40px', maxWidth: '100%' }} />)
            }
        </li>
        <li className='py-4'>
          <p>ID TradeIn</p>
          <p className='text-sm text-gray-600'>{ctx.tradein.id || '-'}</p>
        </li>
        <li className='py-4'>
          <p>Estado actual</p>
          <div className='rounded-full inline text-sm text-white px-2 py-1' style={{ backgroundColor: StatusColor(ctx.tradein.status) }}>{ctx.tradein.status}</div>
        </li>
        <li className='py-4 step-pcheck'>
          <p>Código de evaluación</p>
          <p className='text-sm text-gray-600'>{ctx.tradein.login_code || ctx.tradein.login_code_novabench || 'Sin código'}</p>
          {urlQrCode && (ctx.tradein.id_sbu === 1 || (ctx.tradein.id_sbu === 3 && ctx.tradein.brand === 'Apple')) && (
            <img
              src={urlQrCode}
              alt='QR Code'
              onError={handleQrError}
              width={200}
              height={200}
            />)}
        </li>
        <li className='py-4'>
          <p>Monto de descuento</p>
          <p className='text-sm text-gray-600'>
            <span className={ctx.tradein.new_discount_amount !== null ? 'line-through me-2' : 'me-2'}> {currencyFormat(ctx.tradein.discount_amount, import.meta.env.VITE_COUNTRY)}</span>
            <span hidden={ctx.tradein.new_discount_amount === null}>{currencyFormat(ctx.tradein.new_discount_amount, import.meta.env.VITE_COUNTRY)}</span>
          </p>
          {showWomBoost && (
            <>
              <div className='rounded-full inline-block text-sm text-white bg-blue-600 px-2 py-1 mt-2'>
                Extra Bono: {currencyFormat(Number(ctx.tradein.device_boost), import.meta.env.VITE_COUNTRY)}
              </div>
              <p className='text-base font-bold text-gray-800 mt-2'>
                Total: {currencyFormat(womTotal, import.meta.env.VITE_COUNTRY)}
              </p>
            </>
          )}
        </li>
        {
          configSeller.config.permisos.ENABLE_CONTRIBUTION === 1 && ctx.tradein.contribution_amount !== null
            ? (
              <li className='py-4'>
                <p>Monto campaña</p>
                <p className='text-sm text-gray-600'>
                  <span>{currencyFormat(ctx.tradein.contribution_amount, import.meta.env.VITE_COUNTRY)}</span>
                </p>
              </li>
              )
            : null
        }

        <li className='py-4'>
          <p>Fecha de creación</p>
          <p className='text-sm text-gray-600'>{moment(ctx.tradein.created_at).format('DD-MM-YYYY HH:mm')}</p>
        </li>
      </ul>
    </div>
  )
}

export default Detail
